<template>
  <div
    class="search-filters-header"
  >
    <ais-search-box
      v-if="isOnSearchPage || isOnInternalCmsPage"
      v-slot="{ refine }"
     class="mb-4">

        <form class="ais-SearchBox-form">
          <button
            type="submit"
            class="ais-SearchBox-submit !z-10"
            :aria-label="$t('Submit search')"
            :title="$t('Searchbox submit title')"
          >
            <span class="iconify svg--search text-EXPONDO-primary-80" />
          </button>
          <input
            class="ais-SearchBox-input"
            type="search"
            :maxlength="MAX_LENGTH_FOR_SEARCH_INPUT"
            :placeholder="$t('Searchbox placeholder')"
            :value="currentValue.name"
            :aria-label="$t('Searchbox placeholder')"
            @input="updateSearch($event?.currentTarget?.value, refine)"
          >
          <button
            v-if="currentValue.name"
            class="right-2 top-1/2 -translate-y-1/2 absolute"
            :title="$t('Searchbox reset title')"
            :aria-label="$t('Close')"
            @click="updateSearch('', refine)"
          >
            <span class="iconify svg--close text-EXPONDO-primary-60 pr-0.5" />
          </button>
        </form>


    </ais-search-box>
    <ais-stats v-slot="{ instantSearchInstance }">
<span>
        <span
          v-if="isFiltering(instantSearchInstance.indexName, instantSearchInstance.renderState)"
          class="search-filters-header__title
            flex justify-between text-sm mb-3
          "
        >
          <span class="self-center">{{ $t('Filtering by') }}</span>
          <ClearRefinements />
        </span>
      </span>
</ais-stats>
    <CustomCurrentRefinements />
  </div>
</template>

<script lang="ts">

import {
  AisStats,
  AisSearchBox,
} from 'vue-instantsearch/vue3/es';
import { MIN_CHARS_FOR_SEARCH, MAX_LENGTH_FOR_SEARCH_INPUT } from '~~/constants/typesense';

import { ROUTES } from '~~/constants/routes';

export default defineComponent({
  name: 'SearchFiltersHeader',
  components: {

    AisStats,

    AisSearchBox,
  },
  setup() {

    const router = useRouter();
    const { isFiltering } = useTypesense();
    const { getAdjustedSlug } = useRouteExtended();
    const { isOnSearchPage, isOnInternalCmsPage } = useIsPage();
    const goToSearchPage = () => {

      router.push(getAdjustedSlug(ROUTES.SEARCH));

    };
    const currentValue = ref<{ name: string; url: string; }>({ name: '', url: '' });

    const updateSearch = (value: string, refine: (inputString: string) => void) => {

      if (!value) {

        currentValue.value.name = '';

      }

      if (value.length < MIN_CHARS_FOR_SEARCH) {

        return;

      }
      refine(value);
      currentValue.value = { name: value, url: '' };

    };

    return {
      isFiltering,
      isOnSearchPage,
      isOnInternalCmsPage,
      goToSearchPage,
      updateSearch,
      currentValue,
      MAX_LENGTH_FOR_SEARCH_INPUT,
    };

  },
});

</script>

<style lang="scss" scoped>
@use "~/assets/scss/typesense/_ais-SearchBox" as ais-SearchBox;
@use "~/assets/scss/typesense/_ais-CurrentRefinements" as ais-CurrentRefinements;
</style>
